<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 10:53:27
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-04-09 14:53:28
 * @FilePath: \hzs-nutra-wecom-shop\src\views\BuyerProxyPayment\createCustomerSuc.vue
 * @Description: 代客下单 - 创建客户 成功
-->

<template>
  <div class="page-container">
    <div class="mainContent h100 flex flex-col align-center justify-sc">
      <img src="@/assets/img/customer/success.png" alt="" />
      <span class="tips">客户档案创建成功！</span>
    </div>

    <!-- 底部保存按钮 -->
    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="handleTakeOrder"
      >
        {{ returnBack ? "返回" : "去下单" }}
      </van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();
const { returnBack, returnBackQuery, user_uuid } = route.query;

const handleTakeOrder = () => {
  let path = "";
  if (returnBack) {
    path = returnBack as string;
  } else {
    path = "/takeOrderType";
  }
  let query = { user_uuid, ...JSON.parse((returnBackQuery as string) || "{}") };
  router.push({
    path,
    query,
  });
};
</script>

<style lang="scss">
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.tips {
  height: 22px;
  font-family:
    PingFang SC,
    PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>
